import Component from './SidebarFooter.component';
import UIActions from '/b2b/common/state/ui/UI.actions';
import { connect } from 'react-redux';
import fromState from '/b2b/common/state/selectors';

const mapStateToProps = state => {
    const userId = fromState.Auth.getEmail(state);
    const userEntity = fromState.DB.user.getEntityById(state, userId) || {};
    return {
        notificationCount: fromState.Auth.user.notifications.getResultCount(state),
        notificationsLimit: 4,
        notificationsOpen: fromState.UI.areNotificationsOpen(state),
        urgentNotifications: fromState.Auth.user.notifications.getUrgentNotifications(state),
        userName: userEntity.name || userId,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCloseNotifications: () => dispatch(UIActions.closeNotifications()),
        onOpenNotifications: () => dispatch(UIActions.openNotifications()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Component);
